import { useState } from "react";

function useDialog(): [boolean, () => void, () => void] {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return [open, handleClose, handleOpen];
}

export { useDialog };
